export default __webpack_public_path__ + "static/media/Supplier_Product_Promotion_0708_2008_2025.ca1705a1.xlsx";